import { render, staticRenderFns } from "./DictManager.vue?vue&type=template&id=3cc6c457&scoped=true"
import script from "./DictManager.vue?vue&type=script&lang=js"
export * from "./DictManager.vue?vue&type=script&lang=js"
import style0 from "./DictManager.vue?vue&type=style&index=0&id=3cc6c457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6c457",
  null
  
)

export default component.exports